import "./App.scss";
import { VariantProvider } from "../contexts/useCurrentVariant";
import { ProductProvider } from "../contexts/useCurrentProduct";
import { ActionProvider } from "../contexts/useAction";
import { ConfigProvider, useConfig } from "../contexts/useConfig";
import { ViewerModeProvider } from "../contexts/useViewerMode";
import { VideoModalProvider } from "../contexts/useVideoModal";
import { useGoogleAnalytics } from "../hooks/useGoogleAnalytics";
import { LocalSessionSettingsProvider } from "../contexts/useLocalSessionSettings";
import { useState } from "react";

import ModelViewer from "./ModelViewer/ModelViewer";
import VideoPopupContainer from "./Hotspot/VideoPopup/VideoPopupContainer";
import ViewerUI from "./ViewerUI/ViewerUI";
import { HotspotModalProvider } from "../contexts/useHotspotModal";
import HotspotModalPopup from "./Hotspot/HotspotModalPopup/HotspotModalPopup";

function AppContent() {
   const [config] = useConfig();
   useGoogleAnalytics(config);
   const [uiVisible, setUIVisible] = useState(true);

   return (
      <>
         <ModelViewer toggleUI={setUIVisible}>
         </ModelViewer>
         <ViewerUI uiVisible={uiVisible}/>
         <VideoPopupContainer/>
         <HotspotModalPopup />
      </>
   );
}

export default function App() {
   return (
      <ProductProvider>
         <VariantProvider>
            <LocalSessionSettingsProvider>
               <ViewerModeProvider>
                  <ActionProvider>
                     <ConfigProvider>
                        <HotspotModalProvider>
                        <VideoModalProvider>
                           <AppContent />
                        </VideoModalProvider>
                        </HotspotModalProvider>
                     </ConfigProvider>
                  </ActionProvider>
               </ViewerModeProvider>
            </LocalSessionSettingsProvider>
         </VariantProvider>
      </ProductProvider>
   );
}
